module.exports = __webpack_public_path__ + "img/derby-county-logo-icon.1c301240.webp";